import { render, staticRenderFns } from "./duoYinDuoYi.vue?vue&type=template&id=080a2a7f&scoped=true&"
import script from "./duoYinDuoYi.vue?vue&type=script&lang=js&"
export * from "./duoYinDuoYi.vue?vue&type=script&lang=js&"
import style0 from "./duoYinDuoYi.vue?vue&type=style&index=0&id=080a2a7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a2a7f",
  null
  
)

export default component.exports